<template>
	<el-header height='67px' class="headerWrap">
		<div class="headerBox flex flex-align-center flex-pack-justify">
			<a class="logoWrap" href='/'>
				<img src="@/assets/logo.png" width="100%">
			</a>
			<div class="navWrap flex flex-align-center flex-pack-end">
				<a :href="item.url" class="navItem" v-for="(item,index) in navList" :key="index">{{item.title}}</a>
			</div>
		</div>
	</el-header>
</template>

<script>
	export default {
		data() {
			return {
				navList:[
					// {title:'聘请远程专家',url:'/plan/expert'},
					// {title:'整体项目外包',url:'/plan/outsource'},
					// {title:'我们帮你招聘（支持远程和驻场）',url:'/plan/recruit'},
					// {title:'学生兼职',url:'/plan/recruit#taking'},
					{title:'关于我们',url:'/about'},
				],
				// navList:[
				// 	{title:'聘请远程专家',url:'/'},
				// 	{title:'整体项目外包',url:'/'},
				// 	{title:'我们帮你招聘（支持远程和驻场）',url:'/'},
				// 	{title:'学生兼职',url:'/'},
				// 	{title:'AR眼镜租售',url:'/'},
				// ],
			}
		},
		computed: {
			
		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	.headerWrap{
		width: 100%;
		height: 67px;
		background: rgba(10, 72, 173, 0.7);
		position: relative;
		z-index: 20;
		.headerBox{
			width: 1200px;
			height: 68px;
			margin: 0 auto;
			.logoWrap{
				display: block;
				width: 68px;
				overflow: hidden;
				// >img{
				// 	transform: translateX(300px);
				// 	  filter: drop-shadow(#ff0000 -300px 0px 0px);
				// }
				
			}
			.navWrap{
				width: calc(100% - 200px);
				height: 100%;
				.navItem{
					display: block;
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					font-weight: 500;
					color: #FFFFFF;
					text-shadow: 0px 0px 1px rgba(0,0,0,0.5);
					margin-right: 37px;
					&:last-child{
						margin-right: 0;
					}
					&:hover{
						text-decoration: underline;
					}
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/components/header.vue